import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { typography } from 'src/config/typography';
import { colors } from 'src/config/colors';
import { media } from 'src/config/breakpoints';
import Blocks, { DataProp } from 'editorjs-blocks-react-renderer';
import { editorjsRenderers } from 'src/config/editorjs';
import { StaticPageEditorContent } from 'src/public/components/static-page/StaticPageEditorContent';
import { StrapiFile } from 'src/common/models/strapiFile';
import { prependCMSUrl } from 'src/config/cms';
import { AboutUsInfoItemContainer } from 'src/public/components/about-us/AboutUsInfoItemContainer';
import { StrapiItemResponse } from 'src/common/models/strapi';

const Icon = styled.img`
  width: 1.375rem;
`;

const Number = styled.div`
  color: ${colors.pfp3bis};
  font-family: ${typography.fontFamilyHeaders};
  font-size: 2.3125rem;
  line-height: 1.375rem;

  span {
    font-size: 1rem;
  }
`;

const Text = styled.div`
  color: ${colors.blue};
  font-family: ${typography.fontFamilyHeaders};
  font-size: 0.75rem;
  line-height: 1rem;
  margin-top: 0.5625rem;

  ${media.w.min.px768(css`
    font-size: 1rem;
    line-height: 1.375rem;
  `)}

  p {
    margin: 0 0 1rem;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export interface InfoItemProps {
  id?: string;
  icon?: StrapiItemResponse<StrapiFile>;
  text: DataProp;
  value?: string;
  unit?: string;
}

export const AboutUsInfoItem: FC<InfoItemProps> = ({ icon, text, unit, value }) => (
  <AboutUsInfoItemContainer>
    {icon && <Icon src={prependCMSUrl(icon.data.attributes.url)} />}

    {value && (
      <Number>
        {value} <span>{unit}</span>
      </Number>
    )}

    <Text>
      <StaticPageEditorContent>
        <Blocks data={text} renderers={editorjsRenderers} />
      </StaticPageEditorContent>
    </Text>
  </AboutUsInfoItemContainer>
);
